export type OpenMeteoWeather = {
    current: {
        temperature_2m: number;
        weather_code: number;
        wind_speed_10m: number;
    };
    daily: {
        time: string[];
        weather_code: number[];
        temperature_2m_max: number[];
        temperature_2m_min: number[];
        precipitation_probability_max: number[];
    };
};

export type WeatherPresentation = {
    label: string;
    icon: string;
    accent: string;
};

export async function fetchLocationWeather(latitude: number, longitude: number): Promise<OpenMeteoWeather> {
    const params = new URLSearchParams({
        latitude: String(latitude),
        longitude: String(longitude),
        current: "temperature_2m,weather_code,wind_speed_10m",
        daily: "weather_code,temperature_2m_max,temperature_2m_min,precipitation_probability_max",
        forecast_days: "4",
        timezone: "auto",
    });

    const response = await fetch(`https://api.open-meteo.com/v1/forecast?${params.toString()}`);

    if (!response.ok) {
        throw new Error("Weather request failed");
    }

    return response.json();
}

export const fetchStartLocationWeather = fetchLocationWeather;

export function getWeatherPresentation(weatherCode?: number): WeatherPresentation {
    if (weatherCode === 0) {
        return { label: "Sonnig", icon: "☀", accent: "#f59e0b" };
    }
    if (weatherCode === 1 || weatherCode === 2 || weatherCode === 3) {
        return { label: "Teilweise bewölkt", icon: "⛅", accent: "#60a5fa" };
    }
    if (weatherCode === 45 || weatherCode === 48) {
        return { label: "Nebel", icon: "🌫", accent: "#94a3b8" };
    }
    if ([51, 53, 55, 56, 57].includes(weatherCode ?? -1)) {
        return { label: "Nieselregen", icon: "🌦", accent: "#38bdf8" };
    }
    if ([61, 63, 65, 66, 67, 80, 81, 82].includes(weatherCode ?? -1)) {
        return { label: "Regen", icon: "🌧", accent: "#0284c7" };
    }
    if ([71, 73, 75, 77, 85, 86].includes(weatherCode ?? -1)) {
        return { label: "Schnee", icon: "❄", accent: "#93c5fd" };
    }
    if ([95, 96, 99].includes(weatherCode ?? -1)) {
        return { label: "Gewitter", icon: "⛈", accent: "#7c3aed" };
    }

    return { label: "Wetterdaten", icon: "🌤", accent: "#64748b" };
}
